import WeGlide from 'client/javascript/we_glide/we_glide';
import { logError } from 'client/javascript/util/logger';

const MEDIA_TEXT_ITEM = '.media-text-one-across-item';
const MEDIA_TEXT_GLIDE = '.media-text-one-across__glide';

export function setupMediaTextOneAcrossModuleSection() {
  try {
    const mediaTextElements = document.querySelectorAll(MEDIA_TEXT_ITEM);

    return Array.from(mediaTextElements).reduce((glides, mediaTextElement, index) => {
      if (mediaTextElement.querySelector(MEDIA_TEXT_GLIDE)) {
        const glide = new WeGlide(`${MEDIA_TEXT_ITEM}:nth-child(1n + ${index + 1}) ${MEDIA_TEXT_GLIDE}`);
        glide.mount();
        glides.push(glide);
      }

      return glides;
    }, []);
  } catch (error) {
    logError(`[Shared modules] setupMediaTextOneAcrossModuleSection failed: ${error.message}`, error);
  }
}
